import { RouteRecordRaw } from 'vue-router'

const oAuthRedirectRoutes: RouteRecordRaw = {
  path: '/oAuthRedirect',
  name: 'OAuthRedirect',
  component: () => import('@/layouts/Authentication.vue'),
  meta: {
    title: 'OAuthRedirect'
  },
  children: [
    {
      path: '',
      name: 'OAuthRedirectView',
      component: () => import('@/views/OAuthRedirect/OAuthRedirect.vue'),
      meta: {
        title: 'OAuth Redirect'
      }
    }
  ]
}

export default oAuthRedirectRoutes
